"use strict";

var Backbone = require("backbone");
var _ = require("underscore");

var debug = require("debug")("theme-loader-bw"); //https://github.com/visionmedia/debug

/**
 * Load template and style from a theme. This version verify bandwidth
 * Triggers
 * - sync
 */
var ThemeLoaderBw = function (options) {
    var T = this;

    T.api = null;
    T.id = null;
    T.cacheBreaker = null;
    T.version = null;
    T.hackStyleExt = false; // ajoute .css à la route de récupération du style

    T.templateTag = null;
    T.styleTag = null;

    T.useTemplate = true;

    _.extend(T, options);
    _.extend(T, Backbone.Events); // trigger stuff

    T.fetched = false;
};

ThemeLoaderBw.prototype.addQueryString = function (url, name, value) {
    if (value) {
        url += (url.indexOf("?") == -1 ? "?" : "&");
        url += name + "=" + value;
    }
    return url;
};


/**
 * Load handlebars templates (compiled and packaged in one javascript) and style
 */
ThemeLoaderBw.prototype.fetch = function () {
    var T = this;

    if (T.useTemplate) {
        var script = document.createElement("script");

        var template_url = T.api + "/theme/" + T.id + "/template";
        template_url = T.addQueryString(template_url, "cbrk", T.cacheBreaker);
        template_url = T.addQueryString(template_url, "version", T.version);

        script.src = template_url;
        script.type = "text/javascript";

        script.addEventListener("load", function () {
            debug("templates loaded");
            //on supprime l'éventuel theme précédent
            if (T.templateTag) {
                T.templateTag.parentNode.removeChild(T.templateTag);
            }
            T.templateTag = script;
            T.loadCss();
        });
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    else {
        T.loadCss();
    }
};

ThemeLoaderBw.prototype.loadCss = function () {
    var T = this;

    var css = document.createElement("link");
    css.rel = "stylesheet";
    css.type = "text/css";

    var css_url = T.api + "/theme/" + T.id + "/style";
    if (T.hackStyleExt) {
        css_url += ".css";
    }
    css_url = T.addQueryString(css_url, "cbrk", T.cacheBreaker);
    css_url = T.addQueryString(css_url, "version", T.version);

    css.href = css_url;

    // onload ne fonctionne pas avec toutes les versions de webkit sur le chargement de css
    // donc on utilise une méthode basée sur un timeout (http://www.phpied.com/when-is-a-stylesheet-really-loaded/)
    var cssnum = document.styleSheets.length;
    var ti = setInterval(function () {
        if (document.styleSheets.length > cssnum) {
            clearInterval(ti);

            //on supprime l'éventuel theme précédent
            if (T.styleTag) {
                T.styleTag.parentNode.removeChild(T.styleTag);
            }
            T.styleTag = css;

            debug("style loaded");
            T.fetched = true;
            T.trigger("sync", T.id);

            if (T.abort) {
                T.close(); // pour gérer le cas où on est en train de charger le script/css
            }
        }
    }, 10);

    document.getElementsByTagName("head")[0].appendChild(css);
};


ThemeLoaderBw.prototype.addQueryString = function (url, name, value) {
    if (value) {
        url += (url.indexOf("?") == -1 ? "?" : "&");
        url += name + "=" + value;
    }
    return url;
};


/**
 * Load handlebars templates (compiled and packaged in one javascript) and style
 */
ThemeLoaderBw.prototype.fetch = function () {
    var T = this;

    if (T.useTemplate) {
        var script = document.createElement("script");

        var template_url = T.api + "/theme/" + T.id + "/template";
        template_url = T.addQueryString(template_url, "cbrk", T.cacheBreaker);
        template_url = T.addQueryString(template_url, "version", T.version);

        script.src = template_url;
        script.type = "text/javascript";

        script.addEventListener("load", function () {
            debug("templates loaded");
            //on supprime l'éventuel theme précédent
            if (T.templateTag) {
                T.templateTag.parentNode.removeChild(T.templateTag);
            }
            T.templateTag = script;
            T.loadCss();
        });
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    else {
        T.loadCss();
    }
};

/**
 * Load css via xhr with blob method, return loading speed (Mbit/s)
 */
ThemeLoaderBw.prototype.loadCss = function () {
    var T = this;

    var css_url = T.api + "/theme/" + T.id + "/style";
    if (T.hackStyleExt) {
        css_url += ".css";
    }
    css_url = T.addQueryString(css_url, "cbrk", T.cacheBreaker);
    css_url = T.addQueryString(css_url, "version", T.version);

    var xhr = new XMLHttpRequest();
    var startTime, endTime, fileSize;

    xhr.onreadystatechange = function () {

        if (xhr.readyState === 2) {
            // après chargement headers, on déclenche le chrono
            startTime = performance.now();
        }
        else if (xhr.readyState === 4 && xhr.status === 200) {

            endTime = performance.now();
            fileSize = xhr.responseText.length;

            // Calculate the connection-speed
            var speed = (fileSize * 8) / ((endTime - startTime) / 1000) / 1000000;

            var blob = new Blob([xhr.responseText], { type: 'text/css' });
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            link.href = window.URL.createObjectURL(blob);
            document.querySelector("head").appendChild(link);

            //on supprime l'éventuel theme précédent
            if (T.styleTag) {
                T.styleTag.parentNode.removeChild(T.styleTag);
            }
            T.styleTag = link;

            debug("style loaded");
            T.fetched = true;
            T.trigger("sync", { themeId: T.id, bandwidth: Math.round(speed) });

            if (T.abort) {
                T.close(); // pour gérer le cas où on est en train de charger le script/css
            }
        }
    };

    xhr.open("GET", css_url, true);
    xhr.send();
};



/**
 * Décharge les scripts et les styles chargés précédement
 */
ThemeLoaderBw.prototype.close = function () {
    var T = this;
    T.abort = true; // pour gérer le cas où on est en train de charger le script/css
    if (T.templateTag) {
        T.templateTag.parentNode.removeChild(T.templateTag);
        T.templateTag = null;
    }
    if (T.styleTag) {
        T.styleTag.parentNode.removeChild(T.styleTag);
        T.styleTag = null;
    }
};

module.exports = ThemeLoaderBw;


//////////////////
// WEBPACK FOOTER
// ./src/utils/theme-loader-bw.js
// module id = 56
// module chunks = 0